export default __webpack_public_path__ + "dd28ca3b85d287961e45a3e0f543312a.png";